.footer {
  border-top: 1px solid var(--secondary-color);
  padding: 25px;
  text-align: center;
  font-size: var(--small-text);
  color: var(--secondary-color);
}
